/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { IndexedPriceByDemand } from '@priceOptimizer/models/indexedPriceByDemand';

export class IndexedProductPrice extends DaoModel {
  constructor(product_guid, indexed_price_by_demand) {
    super(product_guid);
    this.indexedPriceByDemand = Object.entries(indexed_price_by_demand).map(([demandType, data]) => new IndexedPriceByDemand(
      demandType,
      data.price,
      data.modification_author,
    ));
  }

  static toInstanceList(pricesData) {
    return Object.entries(pricesData).map(([guid, data]) => new IndexedProductPrice(guid, data));
  }
}
